var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Typography } from "@mui/material";
var Loading = function () {
    return (_jsx(Grid, __assign({ item: true, xs: 12, sx: { display: "flex", justifyContent: "center", mt: 5 } }, { children: _jsx(Typography, __assign({ variant: "body1", sx: { color: "#143971" } }, { children: "Carregando informa\u00E7\u00F5es..." })) })));
};
export default Loading;
